import { Swiper, Navigation, Pagination }  from "swiper";

(function ($) {

  // Install modules
    Swiper.use([ Navigation, Pagination ]);

  // Teaser Slider
    $('.wp-block-events-slider').each(function () {
        const id = '#' + $(this).attr('id');

        new Swiper(id + '.events-slider', {
            speed: 400,
            // loop: true,
            // initialSlide: 2,
            spaceBetween: 0,
            slidesPerView: "auto",
            freeMode: true,
            wrapperClass: "events-slider-wrapper",
            slideClass: "events-slide",
          // centeredSlides: true,
            centerInsufficientSlides: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.events-slider-next',
                prevEl: '.events-slider-prev',
                hiddenClass: 'hidden',
                disabledClass: 'invisible',
                lockClass: 'lock',
            },
        });
    });

})(jQuery);
